import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getMaterialAllocations, type ProductionOrderListItem } from '../../api/productieOrdine'

export default function MaterialAllocationDialog({ target, onClose }: { target: ProductionOrderListItem | null; onClose: () => void }) {
  const open = target !== null
  const { data } = useQuery({ queryKey: ['productie', 'ordine', target?.id, 'alocare'], queryFn: () => getMaterialAllocations(target!.id), enabled: open })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Alocare materiale — {target?.number}</DialogTitle>
      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Componentă</TableCell><TableCell>Depozit</TableCell><TableCell>Zonă/Locație</TableCell>
              <TableCell>Lot</TableCell><TableCell align="right">Cantitate</TableCell><TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((a) => (
              <TableRow key={a.id}>
                <TableCell>{a.componentArticleCode} — {a.componentArticleDescription}</TableCell>
                <TableCell>{a.warehouseName}</TableCell>
                <TableCell>{a.zoneName ?? '—'} {a.locationCode ? `/ ${a.locationCode}` : ''}</TableCell>
                <TableCell>{a.lotNumber ?? '—'}</TableCell>
                <TableCell align="right">{a.quantity}</TableCell>
                <TableCell>{a.isManualOverride && <Chip size="small" color="warning" label={`Manual: ${a.overrideReason}`} />}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
